import { useConstant } from '@talos/kyoko';
import { AnimatePresence } from 'framer-motion';
import React from 'react';
import { useOutlet } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
/**
 * This is a wrapper around the "Outlet" component that renders the route. It ensures that
 * the route is animated when it is mounted and unmounted. Of note, the route child should always be a StackScreen
 * which is a motion.div component that is portalized to the root of the layout.
 *
 * The importance of the portal to the root of the layout is that it allows the route to be animated
 * without being affected by the layout of the parent component.
 * If route confirmation is within route topup, it means that when both routes are animated away,
 * the topup route will show behind the confirmation route (because the confirmation route would be rendered on top).
 * But with portalization, all routes are siblings and are animated independently.
 */
export const AnimatedStackOutlet = () => {
  const element = useOutlet();
  const id = useConstant(uuid());

  return (
    <AnimatePresence mode="wait" initial={true}>
      {element && React.cloneElement(element, { key: id })}
    </AnimatePresence>
  );
};
